import Repository from "./Repository";

const exercises = "/exercises";
const tableOfContent = "/table-of-content";

export default {
  getExercises: () => Repository.get(`${exercises}/`),
  searchExercises: (payload) =>
    Repository.post(`${exercises}/search/`, payload),
  searchQuestions: (payload) =>
    Repository.post(
      `${exercises}/${payload.exercise_id}/search_questions/`,
      payload.params,
    ),
  getExercise: (id) => Repository.get(`${exercises}/${id}/`),
  getExercisesMeta: (payload) =>
    Repository.get(`${tableOfContent}/`, { params: payload }),
  create: (payload) => Repository.post(`${exercises}/`, payload),
  resetTableOfContent: () => Repository.put(`${tableOfContent}/reset/`),
};
